
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34293',
  depVersions: {
  "documents-public-ui": "static-1.34293",
  "client-types": "static-1.457",
  "documents-lib": "static-1.34298",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2044",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4938",
  "highcharts": "static-8.102",
  "hs-promise-utils": "static-1.5508",
  "hs-test-utils": "static-1.7926",
  "hub-http": "static-1.6133",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11373",
  "I18n": "static-7.1604",
  "jasmine-immutable": "static-1.2931",
  "jasmine-runner": "static-1.6381",
  "lodash": "static-1.3",
  "quartz": "static-1.6889",
  "react": "static-7.184",
  "react-dlb": "static-1.77",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16571",
  "reporting-data": "static-1.67124",
  "reporting-testing-lib": "static-1.9057",
  "reporting-visualizations": "static-1.59200",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4682",
  "webpack-env": "static-1.54",
  "atom": "static-1.4984",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2407",
  "classnames": "static-2.10",
  "cssUtils": "static-1.771",
  "customer-data-filters-ui": "static-1.39435",
  "customer-data-objects": "static-1.7573",
  "customer-data-property-utils": "static-1.7998",
  "data-fetching-client": "static-1.9588",
  "enviro": "static-4.428",
  "FireAlarmUi": "static-1.4442",
  "flux-actions": "static-1.325",
  "FormsCommonComponents": "static-1.85610",
  "FormUrlGenerator": "static-2.4632",
  "foundations-components": "static-1.7762",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11681",
  "icons": "static-2.639",
  "immutable": "static-2.77",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7072",
  "metrics-js": "static-1.9542",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.388",
  "property-description-translator": "static-1.3765",
  "property-translator": "static-1.5320",
  "quartz-config": "static-1.667",
  "quartz-core": "static-1.6108",
  "quick-fetch": "static-1.3846",
  "raven": "static-3.5829",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5275",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8081",
  "reference-resolvers-lite": "static-1.8004",
  "report-customization-components": "static-1.12880",
  "reporting-enablement": "static-1.22578",
  "reporting-reports": "static-1.66802",
  "reporting-snowflake": "static-1.55742",
  "reporting-ui-components": "static-2.64395",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4558",
  "sales-content-partitioning": "static-1.8850",
  "SalesContentIndexUI": "static-3.9110",
  "sanitize": "static-1.4386",
  "sanitize-text": "static-1.8058",
  "self-service-api": "static-1.10158",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1663",
  "signup-constants": "static-1.18695",
  "signup-ui-lego-core": "static-1.20705",
  "signup-ui-url-generator": "static-2.7945",
  "styled-components": "static-2.88",
  "StyleGuideUI": "static-3.485",
  "superstore": "static-1.4682",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10904",
  "ui-addon-i18n": "static-1.11062",
  "ui-addon-react-router-dom": "static-1.9458",
  "ui-addon-upgrades": "static-9.17863",
  "ui-asset-management-lib": "static-1.10905",
  "ui-images": "static-2.1131",
  "UIComponents": "static-3.8320",
  "usage-tracker": "static-1.7249",
  "usage-tracker-container": "static-1.7239",
  "usage-tracker-core": "static-1.7099",
  "usage-tracker-public": "static-1.7060",
  "viral-links-lib": "static-1.6961",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven-hubspot": "static-1.6136",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3334",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3166",
  "quartz-webpack": "static-1.3113",
  "ai-components-ui-library": "static-1.8727",
  "amplitude-session-replay-browser": "static-1.58",
  "foundations-assets": "static-1.4765",
  "foundations-theming": "static-1.4328",
  "quartz-auth": "static-1.564",
  "ui-business-units-lib": "static-1.8954",
  "usage-tracker-session-replay": "static-1.4935",
  "foundations-theming-base": "static-1.3313",
  "HeadJS": "static-2.736",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3037",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "hs-locale-management": "static-1.17",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4237",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7838",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3520",
  "persist-promise": "static-1.3623",
  "quartz-i18n": "static-1.564",
  "reporting-client-types": "static-1.2433",
  "foundations-components-legacy": "static-1.787",
  "hs-story-utils": "static-1.9343",
  "react-flip-move": "static-1.68",
  "hub-http-shared-msw-handlers": "static-1.9770",
  "hubspotter-http": "static-1.4582",
  "sassPrefix": "static-1.154",
  "conversations-skeleton-state": "static-1.7164",
  "crm-message-bus": "static-1.42750",
  "customer-data-filters-ui-msw-helpers": "static-1.21870",
  "customer-data-objects-ui-components": "static-1.12934",
  "customer-data-reference-ui-components": "static-1.13069",
  "customer-data-ui-utilities": "static-1.9739",
  "framework-builder-read-service-client": "static-1.3939",
  "framework-data-schema-quick-fetch": "static-1.6693",
  "framework-data-schema-resolvers": "static-1.6788",
  "inbound-db-properties-service-client": "static-1.3773",
  "multi-account-reference-resolvers": "static-1.889",
  "onboarding-tours": "static-1.16443",
  "reporting-datasets-permissions-lib": "static-1.13426",
  "ui-addon-teams": "static-1.21433",
  "apollo-stack-hubspot": "static-3.84",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68093",
  "customer-data-properties": "static-1.51246",
  "forms-ai-lib": "static-1.4184",
  "forms-utils-lib": "static-1.12421",
  "foundations-components-test-utils": "static-1.5245",
  "react-dnd-compat": "static-1.4532",
  "react-tinymce": "static-1.54996",
  "tinymce-config": "static-2.54122",
  "ui-gdpr-components": "static-1.10261",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4031",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1570",
  "ui-fonts": "static-1.635",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.820",
  "mobile-manifest-mixins": "static-1.509",
  "module-federation": "static-1.21",
  "quartz-head": "static-1.554",
  "quartz-routing": "static-1.319",
  "quartz-test": "static-1.564",
  "quartz-tracking": "static-1.268",
  "batch-promise": "static-1.1466",
  "external-options-client-types": "static-1.4088",
  "react-colorpicker": "static-2.10123",
  "copilot-toolkit": "static-1.10893",
  "data-quality-ui-library": "static-1.12654",
  "html-to-image": "static-1.52",
  "onboarding-scopes": "static-1.6378",
  "reporting-action-components": "static-1.41042",
  "reporting-insights-lib": "static-1.1472",
  "reporting-plugins": "static-1.10158",
  "ui-addon-draggable-compat": "static-2.4168",
  "ui-addon-opt": "static-4.8294",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.25113",
  "hubspot-apollo-client": "static-1.4791",
  "chirp-fetch": "static-1.1795",
  "sales-templates-service-types-lib": "static-1.4098",
  "merchandise-lib": "static-1.262",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5715",
  "salesImages": "static-1.523",
  "ts-schema": "static-1.4008",
  "nested-table": "static-1.138",
  "timezone-utils": "static-2.5157",
  "bender-build-tools": "static-1.3063",
  "chatspot-core": "static-1.20897",
  "bend-plugin-foundations-theming": "static-1.2811",
  "stylex": "static-1.30",
  "hubspotter-http-shared-msw-handlers": "static-1.9768",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3727",
  "crm-pipelines-api-client-types": "static-1.4072",
  "multi-currency-client-types": "static-1.3621",
  "getting-started-shared-tasks": "static-1.18259",
  "growth-data-modal": "static-1.5297",
  "growth-onboarding-confetti": "static-1.2984",
  "growth-onboarding-next-action-utils": "static-1.1665",
  "navigation-components": "static-1.17718",
  "onboarding-tours-client": "static-1.4657",
  "onboarding-tours-utils": "static-1.509",
  "ui-shepherd-react": "static-3.10061",
  "ui-shepherd-tracker": "static-1.7442",
  "ui-universal-auth": "static-1.8864",
  "user-context": "static-1.5014",
  "cms-field-types": "static-1.4723",
  "content-icons-ui": "static-1.2204",
  "integrations-lib": "static-1.15841",
  "calling-global-api": "static-1.64168",
  "calling-internal-common": "static-1.31215",
  "calling-lifecycle-internal": "static-1.65550",
  "calling-lifecycle-messages": "static-1.57844",
  "commerce-products-lib": "static-1.9213",
  "crm-links": "static-1.6191",
  "customer-data-properties-shared-msw-handlers": "static-1.9097",
  "file-manager-components": "static-1.23351",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.54",
  "inbounddb-objects-service-types": "static-1.4153",
  "meetings-icalendar-utils-lib": "static-1.543",
  "object-builder-ui-client": "static-1.48452",
  "pipeline-validation-client-types": "static-1.3896",
  "property-value-citations": "static-1.1860",
  "pulse": "static-1.459",
  "smart-property-lib": "static-1.6503",
  "tiered-pricing": "static-1.1036",
  "ui-addon-iframeable": "static-1.8964",
  "final-form": "static-1.68",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19685",
  "tinymce-themes": "static-1.56092",
  "data-token-picker": "static-1.16255",
  "hub-http-contrib": "static-1.2956",
  "interframe": "static-3.4676",
  "tinymce-data": "static-1.40207",
  "tinymce-plugins": "static-1.57236",
  "ui-addon-sales-email": "static-1.5125",
  "magpie-lib": "static-1.5508",
  "magpie-types": "static-1.4968",
  "simple-logging-lib": "static-1.2965",
  "content-assistance-lib": "static-1.7626",
  "dashboard-lib": "static-1.81181",
  "ExportDialog": "static-6.10303",
  "hubspot-prosemirror": "static-1.17992",
  "hubspot-prosemirror-plugins": "static-1.17984",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8609",
  "campaign-roi-lib": "static-1.8717",
  "feedback-loader": "static-1.29141",
  "apollo-link-hub-http": "static-2.4564",
  "hubspot-apollo-cache": "static-1.250",
  "nav-client-types": "static-1.2271",
  "purchase-motions-api": "static-1.5718",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.86",
  "markdown-it": "static-1.6",
  "onboarding-data-sync-lib": "static-1.1815",
  "growth-onboarding-next-action-components": "static-1.1693",
  "user-context-client": "static-1.4525",
  "idb-keyval": "static-1.42",
  "nest": "static-1.137",
  "reactive-lib": "static-1.637",
  "unified-auth-core-lib": "static-1.659",
  "getting-started-shared-tasks-store": "static-1.17377",
  "integrations-error-boundary-lib": "static-1.13256",
  "integrations-tracking-lib": "static-1.5510",
  "native-integrations-shared-strings": "static-1.7699",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10287",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.378",
  "calling-error-reporting": "static-1.31221",
  "shared-worker-versioning": "static-1.10951",
  "calling-usage-tracker": "static-1.6454",
  "voice-sms-access-library": "static-1.658",
  "customer-data-tracking": "static-1.6798",
  "commerce-permissions": "static-1.679",
  "products-iframe-lib": "static-1.7687",
  "products-ui-components-shared-msw-handlers": "static-1.10152",
  "location-customization-utils-lib": "static-1.8978",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4066",
  "video-components-external": "static-1.10997",
  "video-data-lib": "static-1.34655",
  "directed-graph": "static-1.851",
  "event-emitter": "static-1.861",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.60",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9853",
  "fsm": "static-1.3648",
  "policy-lib": "static-1.6697",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9916",
  "navigation-messaging": "static-1.7045",
  "FileManagerLib": "static-1.38991",
  "NamespacedHubStyle": "static-2.8996",
  "FileManagerCore": "static-1.38850",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12279",
  "layout-dnd-utils": "static-1.11254",
  "react-codemirror": "static-1.10537",
  "ui-addon-emoji-picker": "static-1.9800",
  "ui-brand-identity-lib": "static-1.14864",
  "ui-addon-video-player": "static-1.8610",
  "ui-coaching-tips": "static-1.28302",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8459",
  "payment-link-components": "static-1.23288",
  "EmailSignatureEditor": "static-1.24189",
  "InboxConnectUtils": "static-4.14572",
  "universal-page-editor-lib": "static-1.2922",
  "microsoft-drive-integration-lib": "static-1.75",
  "calling-orchestration-schema": "static-1.35435",
  "sales-views-client-types": "static-1.4176",
  "crm-record-cards-service-types": "static-1.3540",
  "content-media-composition-data-lib": "static-1.11988",
  "content-media-compositions": "static-2.15995",
  "media-bridge-lib": "static-1.18776",
  "trellis-story-utils": "static-1.4431",
  "storybook-react": "static-1.31",
  "audio-components": "static-1.5788",
  "FileManagerImages": "static-1.36502",
  "video-components": "static-1.13000",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4445",
  "video-embed": "static-1.35489",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68168",
  "layout-data-lib": "static-1.9579",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6495",
  "commerce-tours-lib": "static-1.5938",
  "growth-onboarding-reliability": "static-1.4998",
  "sales-checkout-service-client": "static-1.3569",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21524",
  "sales-email-signature-service-client": "static-1.3756",
  "social-insights-client-types": "static-1.21845",
  "outpost": "static-1.4106",
  "advanced-menus-core": "static-1.14997",
  "advanced-menus-lib": "static-1.11954",
  "ui-memberships-settings-lib": "static-1.33806",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14996",
  "simple-menus-lib": "static-1.16513"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34293",
  "client-types": "/client-types/static-1.457",
  "documents-lib": "/documents-lib/static-1.34298",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2044",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4938",
  "highcharts": "/highcharts/static-8.102",
  "hs-promise-utils": "/hs-promise-utils/static-1.5508",
  "hs-test-utils": "/hs-test-utils/static-1.7926",
  "hub-http": "/hub-http/static-1.6133",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11373",
  "I18n": "/I18n/static-7.1604",
  "jasmine-immutable": "/jasmine-immutable/static-1.2931",
  "jasmine-runner": "/jasmine-runner/static-1.6381",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6889",
  "react": "/react/static-7.184",
  "react-dlb": "/react-dlb/static-1.77",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16571",
  "reporting-data": "/reporting-data/static-1.67124",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9057",
  "reporting-visualizations": "/reporting-visualizations/static-1.59200",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4682",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4984",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2407",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.771",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39435",
  "customer-data-objects": "/customer-data-objects/static-1.7573",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7998",
  "data-fetching-client": "/data-fetching-client/static-1.9588",
  "enviro": "/enviro/static-4.428",
  "FireAlarmUi": "/FireAlarmUi/static-1.4442",
  "flux-actions": "/flux-actions/static-1.325",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85610",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4632",
  "foundations-components": "/foundations-components/static-1.7762",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11681",
  "icons": "/icons/static-2.639",
  "immutable": "/immutable/static-2.77",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7072",
  "metrics-js": "/metrics-js/static-1.9542",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "property-description-translator": "/property-description-translator/static-1.3765",
  "property-translator": "/property-translator/static-1.5320",
  "quartz-config": "/quartz-config/static-1.667",
  "quartz-core": "/quartz-core/static-1.6108",
  "quick-fetch": "/quick-fetch/static-1.3846",
  "raven": "/raven/static-3.5829",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5275",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8081",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8004",
  "report-customization-components": "/report-customization-components/static-1.12880",
  "reporting-enablement": "/reporting-enablement/static-1.22578",
  "reporting-reports": "/reporting-reports/static-1.66802",
  "reporting-snowflake": "/reporting-snowflake/static-1.55742",
  "reporting-ui-components": "/reporting-ui-components/static-2.64395",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4558",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8850",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9110",
  "sanitize": "/sanitize/static-1.4386",
  "sanitize-text": "/sanitize-text/static-1.8058",
  "self-service-api": "/self-service-api/static-1.10158",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1663",
  "signup-constants": "/signup-constants/static-1.18695",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20705",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7945",
  "styled-components": "/styled-components/static-2.88",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "superstore": "/superstore/static-1.4682",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10904",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11062",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9458",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17863",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10905",
  "ui-images": "/ui-images/static-2.1131",
  "UIComponents": "/UIComponents/static-3.8320",
  "usage-tracker": "/usage-tracker/static-1.7249",
  "usage-tracker-container": "/usage-tracker-container/static-1.7239",
  "usage-tracker-core": "/usage-tracker-core/static-1.7099",
  "usage-tracker-public": "/usage-tracker-public/static-1.7060",
  "viral-links-lib": "/viral-links-lib/static-1.6961",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3334",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3166",
  "quartz-webpack": "/quartz-webpack/static-1.3113",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8727",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4765",
  "foundations-theming": "/foundations-theming/static-1.4328",
  "quartz-auth": "/quartz-auth/static-1.564",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8954",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4935",
  "foundations-theming-base": "/foundations-theming-base/static-1.3313",
  "HeadJS": "/HeadJS/static-2.736",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3037",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "hs-locale-management": "/hs-locale-management/static-1.17",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4237",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7838",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3520",
  "persist-promise": "/persist-promise/static-1.3623",
  "quartz-i18n": "/quartz-i18n/static-1.564",
  "reporting-client-types": "/reporting-client-types/static-1.2433",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.787",
  "hs-story-utils": "/hs-story-utils/static-1.9343",
  "react-flip-move": "/react-flip-move/static-1.68",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9770",
  "hubspotter-http": "/hubspotter-http/static-1.4582",
  "sassPrefix": "/sassPrefix/static-1.154",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7164",
  "crm-message-bus": "/crm-message-bus/static-1.42750",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21870",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12934",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13069",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9739",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3939",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6693",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6788",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3773",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.889",
  "onboarding-tours": "/onboarding-tours/static-1.16443",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13426",
  "ui-addon-teams": "/ui-addon-teams/static-1.21433",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68093",
  "customer-data-properties": "/customer-data-properties/static-1.51246",
  "forms-ai-lib": "/forms-ai-lib/static-1.4184",
  "forms-utils-lib": "/forms-utils-lib/static-1.12421",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5245",
  "react-dnd-compat": "/react-dnd-compat/static-1.4532",
  "react-tinymce": "/react-tinymce/static-1.54996",
  "tinymce-config": "/tinymce-config/static-2.54122",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10261",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4031",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1570",
  "ui-fonts": "/ui-fonts/static-1.635",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.820",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.509",
  "module-federation": "/module-federation/static-1.21",
  "quartz-head": "/quartz-head/static-1.554",
  "quartz-routing": "/quartz-routing/static-1.319",
  "quartz-test": "/quartz-test/static-1.564",
  "quartz-tracking": "/quartz-tracking/static-1.268",
  "batch-promise": "/batch-promise/static-1.1466",
  "external-options-client-types": "/external-options-client-types/static-1.4088",
  "react-colorpicker": "/react-colorpicker/static-2.10123",
  "copilot-toolkit": "/copilot-toolkit/static-1.10893",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12654",
  "html-to-image": "/html-to-image/static-1.52",
  "onboarding-scopes": "/onboarding-scopes/static-1.6378",
  "reporting-action-components": "/reporting-action-components/static-1.41042",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1472",
  "reporting-plugins": "/reporting-plugins/static-1.10158",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4168",
  "ui-addon-opt": "/ui-addon-opt/static-4.8294",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.25113",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4791",
  "chirp-fetch": "/chirp-fetch/static-1.1795",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4098",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5715",
  "salesImages": "/salesImages/static-1.523",
  "ts-schema": "/ts-schema/static-1.4008",
  "nested-table": "/nested-table/static-1.138",
  "timezone-utils": "/timezone-utils/static-2.5157",
  "bender-build-tools": "/bender-build-tools/static-1.3063",
  "chatspot-core": "/chatspot-core/static-1.20897",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2811",
  "stylex": "/stylex/static-1.30",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9768",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3727",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4072",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3621",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18259",
  "growth-data-modal": "/growth-data-modal/static-1.5297",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2984",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1665",
  "navigation-components": "/navigation-components/static-1.17718",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4657",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.509",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10061",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7442",
  "ui-universal-auth": "/ui-universal-auth/static-1.8864",
  "user-context": "/user-context/static-1.5014",
  "cms-field-types": "/cms-field-types/static-1.4723",
  "content-icons-ui": "/content-icons-ui/static-1.2204",
  "integrations-lib": "/integrations-lib/static-1.15841",
  "calling-global-api": "/calling-global-api/static-1.64168",
  "calling-internal-common": "/calling-internal-common/static-1.31215",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65550",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57844",
  "commerce-products-lib": "/commerce-products-lib/static-1.9213",
  "crm-links": "/crm-links/static-1.6191",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9097",
  "file-manager-components": "/file-manager-components/static-1.23351",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.54",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4153",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.543",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48452",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3896",
  "property-value-citations": "/property-value-citations/static-1.1860",
  "pulse": "/pulse/static-1.459",
  "smart-property-lib": "/smart-property-lib/static-1.6503",
  "tiered-pricing": "/tiered-pricing/static-1.1036",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8964",
  "final-form": "/final-form/static-1.68",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19685",
  "tinymce-themes": "/tinymce-themes/static-1.56092",
  "data-token-picker": "/data-token-picker/static-1.16255",
  "hub-http-contrib": "/hub-http-contrib/static-1.2956",
  "interframe": "/interframe/static-3.4676",
  "tinymce-data": "/tinymce-data/static-1.40207",
  "tinymce-plugins": "/tinymce-plugins/static-1.57236",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5125",
  "magpie-lib": "/magpie-lib/static-1.5508",
  "magpie-types": "/magpie-types/static-1.4968",
  "simple-logging-lib": "/simple-logging-lib/static-1.2965",
  "content-assistance-lib": "/content-assistance-lib/static-1.7626",
  "dashboard-lib": "/dashboard-lib/static-1.81181",
  "ExportDialog": "/ExportDialog/static-6.10303",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17992",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17984",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8609",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8717",
  "feedback-loader": "/feedback-loader/static-1.29141",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4564",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.250",
  "nav-client-types": "/nav-client-types/static-1.2271",
  "purchase-motions-api": "/purchase-motions-api/static-1.5718",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.86",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1815",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1693",
  "user-context-client": "/user-context-client/static-1.4525",
  "idb-keyval": "/idb-keyval/static-1.42",
  "nest": "/nest/static-1.137",
  "reactive-lib": "/reactive-lib/static-1.637",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.659",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17377",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13256",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5510",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7699",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10287",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.378",
  "calling-error-reporting": "/calling-error-reporting/static-1.31221",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10951",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6454",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.658",
  "customer-data-tracking": "/customer-data-tracking/static-1.6798",
  "commerce-permissions": "/commerce-permissions/static-1.679",
  "products-iframe-lib": "/products-iframe-lib/static-1.7687",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10152",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8978",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4066",
  "video-components-external": "/video-components-external/static-1.10997",
  "video-data-lib": "/video-data-lib/static-1.34655",
  "directed-graph": "/directed-graph/static-1.851",
  "event-emitter": "/event-emitter/static-1.861",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.60",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9853",
  "fsm": "/fsm/static-1.3648",
  "policy-lib": "/policy-lib/static-1.6697",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9916",
  "navigation-messaging": "/navigation-messaging/static-1.7045",
  "FileManagerLib": "/FileManagerLib/static-1.38991",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8996",
  "FileManagerCore": "/FileManagerCore/static-1.38850",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12279",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11254",
  "react-codemirror": "/react-codemirror/static-1.10537",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9800",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14864",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8610",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28302",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8459",
  "payment-link-components": "/payment-link-components/static-1.23288",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24189",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14572",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2922",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.75",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35435",
  "sales-views-client-types": "/sales-views-client-types/static-1.4176",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3540",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11988",
  "content-media-compositions": "/content-media-compositions/static-2.15995",
  "media-bridge-lib": "/media-bridge-lib/static-1.18776",
  "trellis-story-utils": "/trellis-story-utils/static-1.4431",
  "storybook-react": "/storybook-react/static-1.31",
  "audio-components": "/audio-components/static-1.5788",
  "FileManagerImages": "/FileManagerImages/static-1.36502",
  "video-components": "/video-components/static-1.13000",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4445",
  "video-embed": "/video-embed/static-1.35489",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68168",
  "layout-data-lib": "/layout-data-lib/static-1.9579",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6495",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5938",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4998",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3569",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21524",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3756",
  "social-insights-client-types": "/social-insights-client-types/static-1.21845",
  "outpost": "/outpost/static-1.4106",
  "advanced-menus-core": "/advanced-menus-core/static-1.14997",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11954",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33806",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14996",
  "simple-menus-lib": "/simple-menus-lib/static-1.16513"
}
};
